import React from 'react';
import './Btn4.css';
import btnImg from '../../asserts/bb.png';
import { useMusic } from '../layout/MusicContext';

const Btn4 = ({ label, onClick }) => {
  const { playClick } = useMusic();
  const handleClick = (e) => {
    playClick();
    if (onClick) onClick(e);
  };
  return (
    <button className="btn4" onClick={handleClick}>
      <img className="btn4-bg" src={btnImg} alt="" />
      <span className="btn4-text">{label}</span>
    </button>
  );
};

export default Btn4;